import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { AppConstants } from "src/app/constants/app.constants";
import { ListValues } from "src/app/core/models/list-values";
import { ListValueService } from "src/app/core/services/list-value.service";
import { CertificatesService } from "src/app/certificates/services/certificates.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { DtoReasgineAnalyst } from "src/app/core/models/certificates";
import { InputSelectorWithSearchComponent } from "src/app/shared/input-selector-with-search/input-selector-with-search.component";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-reasigne-analyst",
  templateUrl: "./reasigne-analyst.component.html",
  styleUrls: ["./reasigne-analyst.component.scss"],
})
export class ReasigneAnalystComponent {
  public opened: boolean = false;

  @ViewChild("inputWithSearch")
  inputWithSearch: InputSelectorWithSearchComponent;

  @Input() analyst: string;
  @Input() idPetition: string;
  @Input() peRelease: string;

  @Output() reasgine = new EventEmitter<string>();

  newAnalyst: string;
  roles = AppConstants.roles;

  public analystList: ListValues = {
    list: null,
    loaded: false,
    conf: null,
  };

  constructor(
    private listValueService: ListValueService,
    private toastrAlertService: ToastrAlertService,
    private certificatesService: CertificatesService,
    private translateService: TranslateService
  ) {}

  onOpen(): void {
    this.opened = !this.opened;
    this.getAnalystList();
  }

  getAnalystList() {
    if (!this.analystList || !this.analystList.loaded) {
      this.listValueService.listaAnalistasActivos().subscribe(
        (data) => {
          this.analystList.list = data;
          this.analystList.loaded = true;
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
    }
  }

  onSelect() {
    if (this.newAnalyst && this.newAnalyst != "") {
      let dto: DtoReasgineAnalyst = {
        peId: this.idPetition,
        analista: this.newAnalyst,
        peRelease: this.peRelease.toString(),
      };
      this.certificatesService.reasignedAnalyst(dto).subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(data.mensaje);
          this.reasgine.emit("Reload");
          this.newAnalyst = "";
          this.inputWithSearch.item = "";
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
    } else {
      let fields: string =
        this.translateService.instant("messages.fieldsError") +
        "<br/>Analista (requerido)";
      this.toastrAlertService.toastrFail(fields);
    }
  }

  valueSelector(value: any) {
    if (value.item) {
      this.newAnalyst = value.item.usuarioId;
    }
  }
}
